import { boot } from 'quasar/wrappers'
import axios from 'axios'
import store from 'src/store'

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// Token-based auth doesn't need withCredentials
// axios.defaults.withCredentials = true;

const baseHeaders = {
  "Content-type": 'application/x-www-form-urlencoded',
  "X-Requested-With" : 'XMLHttpRequest'
}

const api = axios.create({
  baseURL: process.env.API_URL,
  headers: baseHeaders
})

// Add request interceptor to include the token in all requests
api.interceptors.request.use(
  function (config) {
    // Get the token from localStorage
    const token = localStorage.getItem('auth_token')

    // If token exists, add it to the Authorization header
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const appID = localStorage.getItem('APP-ID')
    if( appID){
      config.headers['App-id'] = appID
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// Store is imported at the top of the file

api.interceptors.response.use(
  function (response) {
    return response
  },
  function (error){
    if (error.response && error.response.status === 401) {
      // If we get a 401 error, the token is invalid or expired
      console.log('Authentication error: Token invalid or expired')

      // Remove the token from localStorage
      localStorage.removeItem('auth_token')

      // Update login state to trigger logout flow
      store.dispatch('createLoginState', false)

      // Return a rejected promise with the error
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API

})

export { api }
